export default __webpack_public_path__ + "static/media/phone2bgmobile.86437f24.svg";